import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const container = document.getElementById('root');
const app = <React.StrictMode><App /></React.StrictMode>;
if (container.dataset.prerendered === window.location.pathname.replace(/\/$/, '') ||
    (container.dataset.prerendered === '/' && window.location.pathname === '/')) {
  ReactDOM.hydrateRoot(container, app);
} else {
  ReactDOM.createRoot(container).render(app);
}
document.documentElement.dataset.interactive = 'true';

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
